/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import { LeadDetailsContainer } from "../../../../components/LeadDetailsContainer";
import React, { useState, useEffect } from "react";
import { Spin, Button, Modal, Radio, Space, Input, message } from "antd";
import Heading from "../../../../components/Heading";
import urls from "../../../../api/urls";
import API from "../../../../api";
import { useParams, useNavigate } from "react-router";
import Smcs_Loader from "../../../../assests/images/loader-new.gif";
import useCustomNavigate from "../../../../components/customNavigationHook";
// import "./style.scss";
function MasterSigleClientView() {
  const navigate = useCustomNavigate();
  const [loading, setLoading] = useState(false);
  const [leadData, setleadData] = useState([]);
  const { GET_MASTER_CP_ID } = urls;
  const parmas = useParams();

  useEffect(() => {
    getLeadDataById();
  }, []);

  const getLeadDataById = async () => {
    setLoading(true);
    let response = await API.Api(
      GET_MASTER_CP_ID + parmas?.id
    ).getWithUserNPremiseHeader();
    if (response.status) {
      const temp = response?.response?.data;
      const basicDetails = temp?.basicDetail;
      const cpDetailRes = temp?.cpDetail;
      const deliveryDetailRes = temp?.quotation?.deliveryDetails;

      const basicDetail = {
        leadName: basicDetails?.leadName,
        nameOfOwner: basicDetails?.name,
        phoneNumber: basicDetails?.officialNumber,
        emailId: basicDetails?.officialEmailId,
        Remarks: basicDetails?.remark,
        cpName: basicDetails?.premiseName,
        cpType: basicDetails?.cpType,

        addressLine1: basicDetails?.addressLine1,
        addressLine2: basicDetails?.addressLine2,
        PinCode: basicDetails?.pincode,
      };

      const cpDetaildata = {
        cpName: cpDetailRes?.premiseName,
        cpType: cpDetailRes?.cpType,
        motherHubName: cpDetailRes?.parentPremiseName,
        Zone: cpDetailRes?.zone,
        rateCardType: cpDetailRes?.rateCardType,
        billingCycles: cpDetailRes?.billingCycle,
        addressLine1: cpDetailRes?.addressLine1,
        addressLine2: cpDetailRes?.addressLine2,
        PinCode: cpDetailRes?.pincode,
        City: cpDetailRes?.city,
        stateCode: cpDetailRes?.stateCode,
        stateName: cpDetailRes?.state,
      };

      const pinCodeAreaNameInObject = deliveryDetailRes?.areas?.reduce(
        (acc, item, i) => {
          acc[`Delivery Pincode${i}`] = item?.pincode;
          acc[`Area name${i}`] = item?.assignedAreas
            ?.map((area) => area?.areaName)
            .join(", ");
          return acc;
        },
        {}
      );

      const deliveryDetail = {
        ["No. of delivery Pincodes"]: deliveryDetailRes?.areas?.length,
        [`${"CP Pincode"}`]: deliveryDetailRes?.pincode,
        ...pinCodeAreaNameInObject,
      };
      console.log(basicDetail);

      setleadData({ basicDetail, cpDetaildata, deliveryDetail });
      setLoading(false);
    } else {
      if (!response?.status) {
        setLoading(false);
        message.error(response?.response?.data?.message || "Network error");
      }
    }
  };

  const style = {
    viewDetailsContainer: {
      padding: "20px 15%",
    },
    viewDetailsHeader: {
      height: "35px",
      background: "#f5faff",
      border: "1px solid #bfdcff",
      borderRadius: "5px",
      fontWeight: "700",
      fontSize: "16px",
      color: "#061624",
      paddingLeft: "17px",
    },
    leadDetailsGrid: {},
  };

  return (
    <Spin
      spinning={loading}
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <div className="p-2">
        <Heading title="CP Details" />
        <div style={{ background: "white" }}>
          <LeadDetailsContainer
            dataSources={leadData?.basicDetail}
            numberOfColumns={4}
            style={style}
            headingText={"Basic Details"}
          />
          <LeadDetailsContainer
            dataSources={leadData?.cpDetaildata}
            numberOfColumns={4}
            style={style}
            headingText={"CP Details"}
          />
          <LeadDetailsContainer
            dataSources={leadData?.deliveryDetail}
            numberOfColumns={4}
            style={style}
            headingText={"Delivery Details"}
          />
          <hr className="divider" />
        </div>
      </div>
    </Spin>
  );
}

export default MasterSigleClientView;
